import type { ButtonHTMLAttributes } from "react";
import styles from "./text-button.module.css";

/** A quiet action in the accent colour that reads as a link, e.g. "Sign out" under a list. */
export function TextButton({ className, type = "button", ...props }: ButtonHTMLAttributes<HTMLButtonElement>) {
  return <button type={type} className={[styles.button, className].filter(Boolean).join(" ")} {...props} />;
}
